/**
 * Arquivo do registro do prontuário: o que o navegador confere antes de enviar (PDF, PNG ou JPEG de
 * até 9 MB, os mesmos limites do servidor), o tamanho em palavras e o download.
 */

/** Mesmo teto do servidor: o proxy corta a requisição em 10 MB e o multipart pesa mais que o arquivo. */
const LIMITE_EM_BYTES = 9 * 1024 * 1024;

const TIPOS_ACEITOS: Readonly<Record<string, readonly string[]>> = {
  'application/pdf': ['.pdf'],
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
};

export const EXTENSOES_ACEITAS = Object.values(TIPOS_ACEITOS).flat().join(',');

export const DICA_DO_ARQUIVO = 'PDF, PNG ou JPEG, até 9 MB. Um arquivo por registro.';

/** `null` quando o arquivo serve; senão, a frase que diz o motivo e o que fazer. */
export const motivoDeRecusaDoArquivo = (file: File): string | null => {
  const extensao = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
  if (!(TIPOS_ACEITOS[file.type]?.includes(extensao) ?? false)) {
    return `"${file.name}" não é um PDF, PNG ou JPEG. Só aceitamos esses três formatos: salve o documento num deles e escolha de novo.`;
  }
  if (file.size > LIMITE_EM_BYTES) {
    const megas = (file.size / (1024 * 1024)).toLocaleString('pt-BR', { maximumFractionDigits: 1 });
    return `"${file.name}" tem ${megas} MB e o limite é 9 MB. Reduza o arquivo (por exemplo, exporte o PDF em menor qualidade) e escolha de novo.`;
  }
  return null;
};

export const tamanhoEmTexto = (bytes: number): string =>
  bytes < 1024 * 1024
    ? `${Math.max(1, Math.round(bytes / 1024))} KB`
    : `${(bytes / (1024 * 1024)).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} MB`;

/** Entrega o arquivo ao navegador como download, com o nome original. */
export const salvarComoDownload = (blob: Blob, nome: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nome;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
